import noop from 'lodash/noop';
import Backbone from 'backbone';

import alertTemplate from './alert_modern_modal.tpl';

const ConfirmModalView = Backbone.View.extend({

  template: alertTemplate,

  className: "modal hide confirm-modal",

  attributes: {
    'tabindex':'-1',
    'role':'dialog',
    'aria-hidden':"true"
  },

  events: {
    'click .ok':'handleOk',
    'click .cancel':'handleCancel',
    'hidden.bs.modal':'handleHidden',
    'shown.bs.modal':'handleShown',
    'keyup':'handleKeyup'
  },

  alertType: 'confirm',

  initialize: function(options) {
    var me = this,
      opts = (options || {});
    me.cancelText = opts.cancelText || 'Cancel';
    me.okText = opts.okText || 'OK';
    me.body = opts.text || opts.body;
    me.title = opts.title || null;

    me._deferred = $.Deferred();
  },

  handleOk: function() {
    this._deferred.resolve();
    this.hide();
  },

  handleCancel: function() {
    this._deferred.reject();
    this.hide();
  },

  handleHidden: function() {
    if (this._deferred.state() === 'pending') {
      this._deferred.reject();
    }
    this.remove();
  },

  handleKeyup: function(e) {
    if (e.keyCode === 13) {
      this.handleKeyupEnter(e);
    }
  },

  handleKeyupEnter: function(e) {
    this.handleOk();
  },

  handleShown: noop,

  render:function() {
    var me = this;
    me.$el.html(this.template(me)); // Render with the attributes attatched to *this* view
    return me;
  },

  show:function(options) {
    var opts = options || {};
    var me = this;
    if (opts.fade === false) {
      me.$el.removeClass('fade');
    }
    me.render().$el.modal('show');
    return me._deferred.promise();
  },

  hide:function() {
    this.$el.modal('hide');
  }

});



export default ConfirmModalView
